import "../../results.css"
import { GetUser } from "./../../backend/api/database";
import { useAuth } from "./../../context/AuthContext"
import {useState, useEffect } from "react";
import DATA from "./../../personalityCardData";

export default function ResultsMain() {

    const [userInfo, setUserInfo] = useState("");
    const [imgSrc, setImgSrc] = useState("");
    const [title, setTitle] = useState("");
    const [text, setText] = useState("");

    const { currentUser } = useAuth();

    const handleClick = () => {
        window.location.href = "/";
    }

    const loadImage = async (value) => {
        try {
            console.log(`./../../images/planets/Planet${value}.svg`);
          const imgModule = await import(`./../../images/planets/Planet${value}.svg`);
          return imgModule.default;
        } catch (error) {
          console.error(error);
        }
      };

    const handleGetUser = async () => {
        try {
            let user = "";
            if (!currentUser) {
                user = await GetUser("temp")
            } else {

                user = await GetUser(currentUser.uid);
            }

            setUserInfo(user);
            setImgSrc(await loadImage(user));
            const planet = DATA.find(item => item.type === user);
            setTitle(planet.title);
            setText(planet.description);
            console.log(planet);
            console.log(title);
            console.log(text);
        } catch (err) {
          console.error(err);
        }
      }

    const getData = () => {

    }

    useEffect(() => {
        handleGetUser();
      }, []);

    return (
    <main>
    <div className='overall'>
        <div className='overall-container'>
            <div className='results-container'>
                <div className='results-box'>
                    <img src={imgSrc} alt="resultPlanetPic" className="result-image" />
                    <h1>Result: <br></br> {title}!</h1>
                </div>
                <div className='right-section'>
                    <div className='results-box2'>
                        <h1 className='text-results'>What your music personality tells you:</h1>
                        <p className='text-results'>{text}</p>
                    </div>
                    {/* <div className='results-box3'>
                        <h1 className='text-results'>What your music personality tells you:</h1>
                        <p className='text-results'>You are one who prefers listening to X type of music rather than other types such as Y and Z types.</p>
                    </div> */}
                </div>
            </div>
        </div>
       <div className='button1'>
        <div className='results-button' onClick={handleClick}>
                <p className='text-results'>Take another test here!</p>
            </div>
       </div>
    </div>
    </main>
    )
}